import { render, staticRenderFns } from "./AddKinesitherapie.vue?vue&type=template&id=cada2604&scoped=true"
import script from "./AddKinesitherapie.vue?vue&type=script&lang=js"
export * from "./AddKinesitherapie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cada2604",
  null
  
)

export default component.exports